import { render, staticRenderFns } from "./workflowApprove.vue?vue&type=template&id=309a111e&scoped=true&"
import script from "./workflowApprove.vue?vue&type=script&lang=js&"
export * from "./workflowApprove.vue?vue&type=script&lang=js&"
import style0 from "./workflowApprove.vue?vue&type=style&index=0&id=309a111e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a111e",
  null
  
)

export default component.exports